import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
import {useMaterialUIController} from "context";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {GET} from "APIclient";
import {BASE_URL} from "APIclient";
import axios from "axios";
import properties from "constants/ApplicationConstants";
import { formatDesignation } from "constants/ApplicationConstants";
import { formatDate } from "constants/ApplicationConstants";

function AppointmentLetter() {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [data, setData] = useState([]);
  const [details, setDetails] = useState([]);

  const handleCloseSnackbar = () => setSnackbar(null);

  React.useEffect(() => {
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [viewUrl]);

  const formattedDesignation = formatDesignation(details?.designation ?? "-");

  const handlePrintAppointmentLetter = async () => {
    try {
      const url = `${BASE_URL}/admin/employee/downloadCertificate?type=appointment_letter&search=${usersState}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        },
        responseType: "blob",
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch the appointment letter PDF");
      }

      const fileBlob = new Blob([response.data], {type: "application/pdf"});

      const fileUrl = URL.createObjectURL(fileBlob);

      const newWindow = window.open(fileUrl, "_blank");

      if (!newWindow) {
        alert("Please allow pop-ups to view the appointment letter.");
      }
    } catch (error) {
      console.error("Error fetching appointment letter:", error);
      alert("Error generating the appointment letter. Please try again.");
    }
  };

  const downloadAppointmentLetter = async row => {
    try {
      const url = `${BASE_URL}/admin/employee/printCertificate?type=appointment_letter&search=${usersState}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        },
        responseType: "blob",
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch the appointment letter PDF");
      }

      const fileBlob = new Blob([response.data], {type: "application/pdf"});
      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = `Appointment_Letter_${usersState}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating appointment letter:", error);
      alert("Error generating the appointment letter. Please try again.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <Typography
                sx={{
                  color: "textPrimary",
                  fontFamily: properties.fontFamily,
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >
                {" "}
                Appointment Letter
              </Typography>

              {/* <MDBox pt={1} pb={0} px={2}> */}
              <MDBox pt={1} px={2} mb={2}></MDBox>
              <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={2}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Employee Details
                  </MDTypography>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Joining Date:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {formattedDesignation}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        First Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.firstName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Middle Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.middleName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Last Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.lastName : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Personal Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.emailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Official Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.officialEmailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Mobile:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.mobileNo : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Current CTC:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.salary : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Applicable From:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.fromDate) : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              {/* </MDBox> */}
              {/* <DataGrid rows={rows} columns={columns} pagination={false} hideFooter={rows.length <= 20} hideFooterPagination={true} /> */}
              <MDBox pt={2} mb={0} pb={4} px={4}>
                {/* <InputLabel sx={{fontWeight: "bold", paddingBottom: "20px"}}>
                  View Details
                </InputLabel> */}

                <MDBox mr={4} gap={1.5} sx={{textAlign: "center"}}>
                  <MDButton
                    variant="outlined"
                    color="info"
                    sx={{margin: "20px"}}
                    onClick={handlePrintAppointmentLetter}
                  >
                    Print
                  </MDButton>
                  <MDButton
                    variant="outlined"
                    color="info"
                    sx={4}
                    onClick={downloadAppointmentLetter}
                  >
                    View / Download PDF
                  </MDButton>
                </MDBox>
              </MDBox>

              <MDBox
                mt={2}
                mb={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1
                }}
              >
                <MDButton
                  variant="gradient"
                  color="warning"
                  sx={{width: "20ch", fontFamily:properties.fontFamily}}
                  onClick={() => navigate(-1)}
                >
                  Back
                </MDButton>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
              >
                <Alert
                  autoHideDuration={1200}
                  onClose={handleCloseSnackbar}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default AppointmentLetter;
